import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LibraryService } from '../../services/library.service';
import { LazyLoadEvent } from 'primeng/api';
import { DataTableComponent } from '../shared/data-table/data-table.component';
import { TableCustomFilterComponent } from '../shared/table-custom-filter/table-custom-filter.component';
import { CommonModule } from '@angular/common';
import { CvatProjectsService } from '../../services/cvat-projects.service';
import { ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DialogCvatLabelsComponent } from '../shared/dialog-cvat-labels/dialog-cvat-labels.component';

@Component({
  selector: 'app-sidenav-library-objects',
  standalone: true,
  imports: [TableCustomFilterComponent, CommonModule],
  templateUrl: './sidenav-library-objects.component.html',
  styleUrl: './sidenav-library-objects.component.scss'
})
export class SidenavLibraryObjectsComponent {
  @Input() project_id!: number; // Recibe el ID del proyecto desde el componente padre
  @Output() closeSidenav = new EventEmitter<void>();

  libraryObjects: any[] = []
  totalRecords = 0;
  rows = 10;
  first = 0;
  globalFilterFields: string[] = [];
  selectedItems: any[] = [];
  columns: any[] = [];

  constructor(private libraryService: LibraryService, private cvatProjectsService: CvatProjectsService, private route: ActivatedRoute, private _snackBar: MatSnackBar, private dialog: MatDialog) { }
  ngOninit() {
    this.project_id = +this.route.snapshot.paramMap.get('project_id')!;
    console.log('ID EN SIDENAV', this.project_id);
  }

  loadLibraryObjectsLazy(event: LazyLoadEvent) {
    const query = this.buildQuery(event);

    this.libraryService.loadLibraryStore(query).subscribe(res => {
      this.libraryObjects = res.data.map(obj => {
        const attrMap: any = {};

        obj.library_attributes.forEach((attr: any) => {
          const typeName = attr.library_attribute_type.name;
          attrMap[typeName] = attr.name;
        });

        return { ...obj, ...attrMap };
      });
      this.totalRecords = res.meta.totalItems;
      this.columns = this.buildColumns(this.libraryObjects);
    });
  }

  private buildQuery(event: LazyLoadEvent): any {
    const sortField = event.sortField ?? undefined;
    let sortOrder: string | undefined;
    if (event.sortOrder === 1) {
      sortOrder = 'ASC';
    } else if (event.sortOrder === -1) {
      sortOrder = 'DESC';
    }
    return {
      page: Math.floor((event.first ?? 0) / (event.rows ?? 10)) + 1,
      limit: event.rows ?? 10,
      search: event.globalFilter ?? undefined,
      sortBy: sortField ? [`${sortField}:${sortOrder}`] : undefined
    };
  }


  private buildColumns(data: any[]): any[] {
    if (!data.length) return [];

    const baseCols = [
      { field: 'name', header: 'Name', orderby: false, filter: false },
      { field: 'label', header: 'Label', orderby: false, filter: false },
      { field: 'description', header: 'Description', orderby: false, filter: false }
    ];

    const attributeTypes = new Map<number, string>();
    data.forEach(obj => {
      obj.library_attributes.forEach((attr: any) => {
        attributeTypes.set(attr.library_attribute_type_id, attr.library_attribute_type.name);
      });
    });

    const attributeCols = Array.from(attributeTypes.values()).map(name => ({
      field: name,
      header: name,
      orderby: false,
      filter: false
    }));

    return [...baseCols, ...attributeCols];
  }

  onLibraryObjectsAccepted(selectedProducts: any[]) {
    if (!selectedProducts.length) return;

    this.cvatProjectsService
      .addLabelsProjectCvat(this.project_id, selectedProducts)
      .subscribe({
        next: res => {
          const added = res.added ?? [];
          const duplicated = res.duplicated ?? [];

          if (selectedProducts.length === 1) {
            if (added.length === 1) {
              this._snackBar.open(
                `Etiqueta "${added[0]}" agregada exitosamente`,
                'Cerrar',
                { duration: 4000 }
              );
              this.onCloseSidenav();
            } else if (duplicated.length === 1) {
              this._snackBar.open(
                `La etiqueta "${duplicated[0]}" ya existe en el proyecto`,
                'Cerrar',
                { duration: 4000 }
              );
            }
            return;
          }


          if (added.length && duplicated.length) {
            const snackRef = this._snackBar.open(
              `${added.length} agregadas correctamente y ${duplicated.length} fallaron`,
              'Ver',
              { duration: 5000, verticalPosition: 'bottom', horizontalPosition: 'center' }
            );

            snackRef.onAction().subscribe(() => {
              this.dialog.open(DialogCvatLabelsComponent, {
                position: { top: '20rem', right: '30rem' },
                data: {
                  title: 'Detalle en la carga de etiquetas',
                  duplicate: duplicated,
                  added: added
                }
              });
            });
          } else if (added.length) {
            // Todas agregadas
            this._snackBar.open(
              `${added.length} etiquetas agregadas exitosamente`,
              'Cerrar',
              { duration: 4000 }
            );
          } else if (duplicated.length) {
            // Todas duplicadas
            this._snackBar.open(
              `${duplicated.length} etiquetas no fueron agregadas porque ya existen en el proyecto`,
              'Cerrar',
              { duration: 4000 }
            );
          }
        },
        error: err => {
          this._snackBar.open(`Error: ${err.error.message}`, 'Cerrar');
          console.error('Error', err);
        }
      });
  }




  onSelectionChange(event: any) {
    console.log('event', event)
    this.selectedItems = event
  }

  onRowSelect(event: any) {
    console.log('evento', event)
  }

  onCloseSidenav() {
    console.log('Cerrando sidenav desde los library');
    this.closeSidenav.emit();
   } 


}
